import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { JoyrideError, JoyrideStepOutOfRange, JoyrideStep } from '../joyride.domain';
import { JoyrideOptionsService } from './joyride-options.service';

class Step {
  id: string;
  step: JoyrideStep;
}

export enum StepActionType {
  NEXT = 'NEXT',
  PREV = 'PREV'
}

@Injectable({ providedIn: 'root' })
export class JoyrideStepsContainerService {
  stepHasBeenModified: Subject<JoyrideStep> = new Subject<JoyrideStep>();
  private steps: Array<Step>;
  private tempSteps: Array<JoyrideStep> = [];
  private currentStepIndex: number = -2;

  constructor(private readonly stepOptions: JoyrideOptionsService) { }

  init(): void {
    // Initializing the steps array.
    this.steps = [];
    this.currentStepIndex = this.getFirstStepIndex() - 1;
    const stepIds = this.stepOptions.getStepsOrder();
    stepIds.forEach((stepId: string) => this.steps.push({ id: stepId, step: null }));
  }

  addStep(stepToAdd: JoyrideStep): void {
    const stepExist = this.tempSteps.filter((step: JoyrideStep) => step.name === stepToAdd.name).length > 0;
    if (!stepExist) {
      // `Adding step ${stepToAdd.name} to the steps list.
      this.tempSteps.push(stepToAdd);
    } else {
      const stepIndexToReplace: number = this.tempSteps.findIndex((step: JoyrideStep) => step.name === stepToAdd.name);
      this.tempSteps[stepIndexToReplace] = stepToAdd;
    }
  }

  get(action: StepActionType): JoyrideStep {
    if (action === StepActionType.NEXT) {
      this.currentStepIndex++;
    } else {
      this.currentStepIndex--;
    }

    if (this.currentStepIndex < 0 || this.currentStepIndex >= this.steps.length) {
      throw new JoyrideStepOutOfRange('The first or last step of the tour cannot be found!');
    }

    const stepName = this.steps[this.currentStepIndex].id;
    const index = this.tempSteps.findIndex((step: JoyrideStep) => step.name === stepName);
    const stepFound = this.tempSteps[index];
    this.steps[this.currentStepIndex].step = stepFound;

    if (stepFound == null) {
      // Step ${this.steps[this.currentStepIndex].id} not found in the DOM. Check if it's hidden by *ngIf directive.
    }
    return stepFound;
  }

  updatePosition(stepName: string, position: string): void {
    const index = this.getStepIndex(stepName);
    if (this.steps[index].step) {
      this.steps[index].step.position = position;
      this.stepHasBeenModified.next(this.steps[index].step);
    } else {
      // Trying to modify the position of ${stepName} to ${position}. Step not found!Is this step located in a different route?
    }
  }

  getStepNumber(stepName: string): number {
    return this.getStepIndex(stepName) + 1;
  }

  getStepsCount(): number {
    const stepsOrder = this.stepOptions.getStepsOrder();
    return stepsOrder.length;
  }

  private getFirstStepIndex(): number {
    const firstStep = this.stepOptions.getFirstStep();
    const stepIds = this.stepOptions.getStepsOrder();

    let index = stepIds.indexOf(firstStep);
    if (index < 0) {
      index = 0;
      if (firstStep !== undefined) {
        // `The step firstStep does not exist. Check in your step list if it's present.`);
      }
    }
    return index;
  }

  private getStepIndex(stepName: string): number {
    const index = this.steps
      .map((step: Step) => step.id)
      .findIndex((name: string) => stepName === name);
    if (index === -1) {
      throw new JoyrideError(`The step with name: ${stepName} does not exist in the step list.`);
    }
    return index;
  }
}
